// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"84e459a2","787":"7a79f6af","913":"839677ec"}[chunkId] + ".chunk.js";
};